import { ToastrService } from 'ngx-toastr';
import { ViewChild } from '@angular/core';
import {
  Component,
  OnInit,
  Input,
  EventEmitter,
  ViewEncapsulation
} from '@angular/core';
import {
  Tarea,
  DynamicComponentForm,
  Context,
  ConfigFinishDefault,
  TaskEvent,
  Const,
  ConfirmComponent,
} from '@app/shared';

@Component({
  selector: 'iw-radication',
  templateUrl: './radication.component.html',
  styleUrls: ['./radication.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class RadicationComponent extends DynamicComponentForm implements OnInit {
  // Variable que trae la información de la tarea.
  @Input() ctx: Context;
  // Variable que sirve para disparar el evento de las finalizaciones
  @Input() event: EventEmitter<TaskEvent>;
  // tipo del proceso de la tarea renderizada
  typeProcess: string;
  // Variable que valida los tipos de documentos que se pueden subir
  extensions: Array<String> = [
    'image/tiff-fx',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/pdf',
    'image/jpg',
    'image/png',
    'image/jpeg',
    'image/tif',
    'image/tiff',
  ];
  // Label de las extensiones permitidas
  extensionsLabel = 'jpg, png, pdf, xlsx, xls, docx, doc, tiff, tif';
  // Define la finaliacioncion de la tarea
  finishTask = false;
  // Define si hay una secundaria iniciada
  secondaryActive = false;
  // Variable que activa el gift de cargando cuando se está finalizando
  isLoadingFinish = false;
  // Variable que verifica si los documentos ya se radicadon
  radicateCompleted = false;
  // Determina si el usuario en sesion es responsable de la tarea
  userResponsible = false;
  // Variable que contiene el objeto de la tarea
  task: Tarea;
  // Referencia al componente de confirmación
  @ViewChild('confirmFinish') private confirmFinish: ConfirmComponent;

  constructor(private toastr: ToastrService) {
    super();
  }

  ngOnInit() {
    this.task = this.ctx.task;
    this.typeProcess = this.ctx.typeProcess;
    if (
      this.task &&
      this.task.tarea_estado &&
      this.task.tarea_estado.nombre === Const.STATUS_TASK.finished
    ) {
      this.finishTask = true;
    }
    if (
      this.task &&
      this.task.tarea_estado &&
      this.task.tarea_estado.nombre === Const.STATUS_TASK.secondaryProgress
    ) {
      this.secondaryActive = true;
    }
  }

  /**
   * Actualiza la informacion de la tarea en el flujo principal
   *
   * @param {*} data
   * @memberof RadicationComponent
   */
  async documentUpdate(data: Tarea) {
    this.ctx.task = data;
    this.updateTask(this.ctx.task);
  }

  /**
   * Función que realiza las validaciones de la finalización.
   *
   * @private
   * @param {boolean} res
   * @memberof RadicationComponent
   */
  finish(res: boolean) {
    if (res) {
      const data: ConfigFinishDefault = {
        tarea: this.task.id
      };
      const e: TaskEvent = {
        type: 'finish',
        data: data
      };
      this.event.emit(e);
      this.close();
    }
  }

  /**
   * Controla la validacion de radicacion de los documentos del componente de radicacion
   *
   * @param {boolean} res
   * @memberof RadicationComponent
   */
  completeRadication(res: boolean) {
    this.radicateCompleted = !res;
  }

  /**
   * Validad que la tarea se pueda finalizar
   *
   * @memberof ApproveComponent
   */
  finishConfirm() {
    if (!this.radicateCompleted && this.userResponsible && !this.finishTask && !this.secondaryActive) {
      this.confirmFinish.open();
    } else {
      if (!this.userResponsible) {
        this.toastr.error('Usted no posee los permisos suficientes para ejecutar esta acción.', 'Permiso denegado');
      } else if (this.finishTask) {
        this.toastr.error('La tarea ya está finalizada.', 'Acción no permitida');
      } else if (this.secondaryActive) {
        this.toastr.error(
          'No se puede realizar esta acción debido a que se encuentra un procesos secundario en progreso.',
          'Acción no permitida'
        );
      } else if (this.radicateCompleted) {
          this.toastr.error('Por Favor ingrese toda la información requerida.', 'Información incompleta');
      } else {
        this.toastr.error(
          'Lo sentimos ha ocurrido un error inesperado, inténtalo de nuevo más tarde.',
          'Error inesperado'
        );
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/forms/all/radication/radication.component.ts